import { Controller } from '@hotwired/stimulus';
import Cookies from 'js-cookie';

export default class SearchLinkController extends Controller {
  performSearch(event) {
    event.preventDefault();

    Cookies.set('ezSearchType', 'internal', { domain: this.cookieDomain });

    if (this.url) {
      Turbolinks.visit(this.url);
    }
  }

  get cookieDomain() {
    const cookieDomainArray = window.location.hostname.split('.');
    return `${cookieDomainArray[1]}.${cookieDomainArray[2]}`;
  }

  get url() {
    return this.element.getAttribute('href');
  }
}
